import { ILanguage } from 'common/types/common'
import { Container } from 'components/ui'
import { useTranslation } from 'react-i18next'
import useCategoriesContext from 'routes/categories/services/categoriesContext'
import { imgUrl } from 'utils/imgUrl'

const CategoryHeader = () => {
  const { t } = useTranslation()
  const { i18n } = useTranslation()
  const {
    state: { data }
  } = useCategoriesContext()
  return (
    <div
      className="category-header"
      style={{
        backgroundImage: `url(${imgUrl(data?.category.image)})`
      }}
    >
      <Container size="xxl" style={{ textAlign: 'center' }}>
        <h1 className="cormorant-title">
          {data?.category.name[i18n.language as ILanguage]}
        </h1>
        <p>
          {data?.data?.length || 0} {t('categories.available_products')}
        </p>
      </Container>
    </div>
  )
}

export default CategoryHeader
